import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
    constructor() {
        super('BootScene');
    }

    preload() {

    }

    create() {
      // @ts-ignore
      if (typeof PblInterface !== 'undefined') {
        // @ts-ignore
        PblInterface.game.ready();
      } else {
        window._po_gm.ready();
      }
      // Un-comment for local dev
     /* const startConfig =  {
        'gameType': 'fun',
        'winType' : '03' ,
        'callLetters': "BSUNDKFZGWAVMOPHIERT",
        'gridLetters': "#PIN##BLOCK###E#M#A#I#Y#NEGOTIATEO##D#L#R#E#U#FLEE##U##R##E#H##T#MS#A#HICKORYEGG##L##P#SL#OVAL##I#EFAN#Y##NAIL##YIELD###F",
        'pulse' : '2', //pulse 1 = blue, pulse 2= pink.
        'messages': {
          'eog_code': "CODE: X222KF62FH2"
        }

      };


      window.po_gm.start(startConfig);*/
    }
}
